import { makeStyles } from '@material-ui/core';

const materialStyles = (theme) => ({
  '@global': {
    '#CARD_ELEMENT_ID': {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(0, 2),
      height: 32,
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    }
  },
  cardContainer: {
    flexGrow: 1,
    marginBottom: 0,
    marginRight: theme.spacing(2)
  },
  submit: {
    width: ({ fromModal }) => (fromModal ? 'fit-content' : 168),
    padding: theme.spacing(0, 4),
    marginRight: ({ fromModal }) => (fromModal ? 0 : theme.spacing(6)),
    marginTop: ({ fromModal }) => (fromModal ? theme.spacing(2) : 'inherit'),
    fontWeight: 600
  },
  container: {
    padding: theme.spacing(2, 7),
    backgroundColor: 'rgba(255, 255, 255, 0.1)'
  },
  label: {
    lineHeight: 1.2,
    fontWeight: 600,
    marginBottom: theme.spacing(2)
  },
  loadingBar: {
    height: 2,
    width: ({ fromModal }) => (fromModal ? '100%' : 'inherit')
  }
});

export const styles = (theme) => ({
  cardElementStyle: {
    base: {
      fontSize: 14,
      fontFamily: '"Libre Franklin", sans-serif',
      color: theme.colorPalette.green_75,
      fontWeight: '400',
      backgroundColor: theme.palette.common.white,
      '::placeholder': {
        fontSize: 14,
        color: theme.colorPalette.grey_10_op_38
      }
    },
    invalid: {
      color: theme.palette.error.main
    }
  }
});

export default makeStyles(materialStyles);
